import { render, staticRenderFns } from "./widgets.vue?vue&type=template&id=56a2c998"
import script from "./widgets.vue?vue&type=script&lang=js"
export * from "./widgets.vue?vue&type=script&lang=js"
import style0 from "./widgets.vue?vue&type=style&index=0&id=56a2c998&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports